<template>
  <main class="tab-content">
    <div :class="['admin-tab-pane fade', { 'show active': ids.includes(fit20.selectedTabHref) }]" id="studio">
      <Blocks :fit20="fit20" v-if="true">
      </Blocks>
    </div>
    <div :class="['admin-tab-pane fade', { 'show active': studiosIds.includes(fit20.selectedTabHref.split('-')[0]) }]"
      id="studio">
      <Studios :fit20="fit20">
      </Studios>
    </div>
    <div :class="['admin-tab-pane fade', { 'show active': fit20.selectedTabHref == 'URLS' }]" id="studio">
      <Urls :fit20="fit20">
      </Urls>
    </div>
    <div>
      <Block :fit20="fit20" v-if="fit20.blockToEdit.id" :saveBlock="saveBlock" :cancelEditing="cancelEditing"></Block>
    </div>
  </main>
</template>

<script>

import Blocks from "./Blocks.vue";
import Block from "./Block.vue";
import Studios from "./Studios.vue";
import Urls from "./Urls.vue";

export default {
  name: 'Content',
  components: {
    Block,
    Blocks,
    Studios,
    Urls
  },
  props: ['fit20', "saveBlock", "cancelEditing"],
  data() {
    return {
      ids: ['studio', 'country', 'franchise'],
      studiosIds: ['studios_country', 'studios_franchise'],
    };
  },
};
</script>

<style>
.admin-tab-pane {
  display: none;
}
</style>
